import { memo, type FC } from 'react';

import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.tsx';
import { dataTableSection } from '../../constants.ts';
import { useTableContext } from '../../context.tsx';
import { ActionsWrapper, CardHeaderWrapper, ContentWrapper, TabsWrapper, TitleWrapper } from './styled.ts';
import type { CardHeaderProps } from './types.ts';

export const CardHeader: FC<CardHeaderProps> = memo(function CardHeader({
  className,
  title,
  tooltip,
  tooltipPosition,
  tabs,
  actions,
  dataTestId,
}) {
  const { compact } = useTableContext();

  return (
    <CardHeaderWrapper className={className} {...dataTableSection} data-testid={dataTestId}>
      {(title || actions) && (
        <ContentWrapper $compact={compact}>
          {title && (
            <TitleWrapper>
              <span>{title}</span>
              {tooltip && <InfoTooltipIcon placement={tooltipPosition} tooltip={tooltip} size={24} />}
            </TitleWrapper>
          )}
          {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
        </ContentWrapper>
      )}
      {tabs && <TabsWrapper $compact={compact}>{tabs}</TabsWrapper>}
    </CardHeaderWrapper>
  );
});
